import React, { Component } from 'react';
import StructuredData from './StructuredData';

/**
 * Premium expand/collapse FAQ with FAQPage schema.
 *
 * Props:
 *   faqs       - array of { q, a }
 *   withSchema - boolean, emit FAQPage JSON-LD (default true)
 */
class FaqAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = { openIndex: null };
  }

  toggle = (i) => {
    this.setState((prev) => ({
      openIndex: prev.openIndex === i ? null : i,
    }));
  };

  render() {
    const { faqs = [], withSchema = true } = this.props;
    const { openIndex } = this.state;

    if (faqs.length === 0) return null;

    const schema = withSchema
      ? {
          '@type': 'FAQPage',
          mainEntity: faqs.map((f) => ({
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: { '@type': 'Answer', text: f.a },
          })),
        }
      : null;

    return (
      <>
        {schema && <StructuredData data={schema} />}
        <div className="rr-faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className="rr-faq-item">
              <button
                className="rr-faq-q"
                onClick={() => this.toggle(i)}
                aria-expanded={openIndex === i}
              >
                <span>{faq.q}</span>
                <span className={`rr-faq-chevron${openIndex === i ? ' rr-faq-chevron--open' : ''}`}>
                  +
                </span>
              </button>
              {openIndex === i && (
                <div className="rr-faq-a">{faq.a}</div>
              )}
            </div>
          ))}
        </div>
      </>
    );
  }
}

export default FaqAccordion;
